import { completeAppwriteEmailVerification } from './appwriteAuth';

const inflight = new Map<string, Promise<void>>();

function storageKey(userId: string, secret: string): string {
  return `pixlie:email-verified:${userId}:${secret}`;
}

/**
 * Idempotent Appwrite email verification — prevents duplicate calls from
 * AppEmailVerificationGate + VerifyEmailPage + legacy Login handlers.
 */
export async function verifyEmailOnce(userId: string, secret: string): Promise<void> {
  const trimmedUserId = userId.trim();
  const trimmedSecret = secret.trim();
  if (!trimmedUserId || !trimmedSecret) {
    throw new Error('Verification link is incomplete.');
  }

  const key = `${trimmedUserId}:${trimmedSecret}`;
  if (typeof sessionStorage !== 'undefined') {
    if (sessionStorage.getItem(storageKey(trimmedUserId, trimmedSecret))) {
      return;
    }
  }

  const pending = inflight.get(key);
  if (pending) {
    return pending;
  }

  const run = completeAppwriteEmailVerification(trimmedUserId, trimmedSecret)
    .then(() => {
      if (typeof sessionStorage !== 'undefined') {
        sessionStorage.setItem(storageKey(trimmedUserId, trimmedSecret), '1');
      }
    })
    .finally(() => {
      inflight.delete(key);
    });

  inflight.set(key, run);
  return run;
}
